// extracted by mini-css-extract-plugin
export var clauseRow = "_fu-6";
export var emptyState = "_fu-d";
export var filterContent = "_fu-a";
export var filterGroup = "_fu-1";
export var filterGroupContainer = "_fu-0";
export var nestedGroup = "_fu-2";
export var nestedGroupContent = "_fu-b";
export var nestedGroupDepth1 = "_fu-3";
export var nestedGroupDepth2 = "_fu-4";
export var nestedGroupDepth3 = "_fu-5";
export var nestedGroupEmpty = "_fu-c";
export var operatorAnd = "_fu-8";
export var operatorOr = "_fu-9";
export var operatorToggle = "_fu-7";
export var removeGroupButton = "_fu-e";